import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { checkoutUrl, pricing } from '../data/content';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-239" data-mp="3hdsop7dlu9z6">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-panel/95 backdrop-blur" data-id="element-240" data-mp="3vebsu3ey8vw2">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3 sm:px-8" data-id="element-241" data-mp="1w1r79fwzet2k">
            <div className="min-w-0" data-id="element-242" data-mp="29f9aovkwopjm">
              <p className="truncate font-display text-lg font-bold uppercase leading-none tracking-tight text-white sm:text-xl" data-id="element-243" data-mp="29gamj29qxg2e">
                6 manuals + 5 strategic bonuses
              </p>
              <p className="mt-1 text-xs text-white/45" data-id="element-244" data-mp="2iduueu246alz">
                <span className="line-through" data-id="element-245" data-mp="2n6nyrgto7gxj">{pricing.compare}</span>
                <span className="ml-2 font-semibold text-acid" data-id="element-246" data-mp="2n7z2xhr12qp6">
                  {pricing.price} today
                </span>
              </p>
            </div>
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} className="shrink-0 rounded-sm bg-acid px-5 py-3 font-display text-lg font-bold uppercase leading-none text-night transition-colors duration-150 ease-smooth hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-acid focus-visible:ring-offset-2 focus-visible:ring-offset-night sm:text-xl" data-id="element-247" data-mp="2x30sgep7tusa">
              Get instant access
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}